import { render, staticRenderFns } from "./dataProtectionPage.vue?vue&type=template&id=a27b1fb4&"
import script from "./dataProtectionPage.vue?vue&type=script&lang=js&"
export * from "./dataProtectionPage.vue?vue&type=script&lang=js&"
import style0 from "./dataProtectionPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dataProtectionPage.vue"
export default component.exports